import { api } from "./client";

/* Notes on a customer or a vendor (server/record-notes.js): append-only, newest first. Adding one goes through the phone
 * app's outbox (src/ui/RecordNotes.tsx), so it is kept on the device with no connection and recorded once. */

export type NoteEntity = "customers" | "vendors";
export type RecordNote = { id: string; body: string; created_by: string | null; created_by_name: string | null; created_at: string };

// Written out per entity, so each path's permission module is plain (server/access-registry.js; test-wave3 checks it).
export const notesPath = (entity: NoteEntity, id: string) => (entity === "customers" ? `/admin/notes/customers/${encodeURIComponent(id)}` : `/admin/notes/vendors/${encodeURIComponent(id)}`);

export const recordNotes = {
  list: (entity: NoteEntity, id: string) => api<RecordNote[]>("GET", notesPath(entity, id)),
  remove: (entity: NoteEntity, id: string, noteId: string) => api<RecordNote[]>("DELETE", `${notesPath(entity, id)}/${noteId}`),
};
